export const common = {
  nav: {
    platform: '平台',
    solutions: '解决方案',
    resources: '资源',
    company: '公司',
    requestDemo: '申请演示',
    // Platform dropdown
    dashboard: '仪表盘',
    analytics: '数据分析',
    monitoring: '监控',
    compliance: '合规管理',
    // Solutions dropdown
    iotDevices: '物联网设备',
    dataManagement: '数据管理',
    aiAlerts: 'AI 告警',
    cbamCompliance: 'CBAM 合规',
    // Resources dropdown
    documentation: '文档',
    apiReference: 'API 参考',
    caseStudies: '案例研究',
    blog: '博客',
    // Company dropdown
    about: '关于我们',
    careers: '招聘',
    contact: '联系我们',
    privacy: '隐私政策',
  },
  hero: {
    badge: '工业物联网平台',
    title1: '数字化转型',
    title2: '实时监控',
    title3: '碳排放合规',
    subtitle: '通过 AI 驱动的洞察、实时数据处理和欧盟碳足迹合规解决方案，赋能您的工业运营',
    startTrial: '免费试用',
    watchDemo: '观看演示',
    scrollExplore: '向下滚动探索',
    // Statistics
    stat1Value: '500+',
    stat1Label: '企业客户',
    stat2Value: '50,000+',
    stat2Label: '连接设备',
    stat3Value: '1000万+',
    stat3Label: '数据点/天',
    stat4Value: '99.9%',
    stat4Label: '正常运行时间'
  },
  features: {
    sectionTitle: '核心解决方案',
    sectionSubtitle: '工业数字化转型的综合平台',
    feature1Title: '设备监控',
    feature1Desc: '通过先进的传感器网络和物联网连接，对工业设备进行实时监控。支持 Modbus、RS485、OPC-UA、Snap7 等 15+ 种工业协议，拥有 20 年现场经验。',
    feature2Title: '数据生命周期管理',
    feature2Desc: '完整的数据流程：从工业设备经智能边缘处理到云端——遥测采集、本地处理、传输、ETL、数据总线、存储与展示。',
    feature3Title: 'AI 智能告警',
    feature3Desc: '双模告警：自定义阈值与条件规则，或让 AI 自动检测异常和异常模式——在问题升级前及时通知您。',
    feature4Title: 'CBAM 合规',
    feature4Desc: '欧盟碳边境调节机制合规解决方案，支持自动化报告生成',
    learnMore: '了解更多'
  },
  dashboard: {
    badge: '实时仪表盘预览',
    title: '实时监控一切',
    subtitle: '可定制的仪表盘，支持拖拽组件、实时告警和全面的数据可视化',
    metric1: '99.9%',
    metric1Label: '正常运行时间',
    metric2: '<50ms',
    metric2Label: '响应时间',
    metric3: '10K+',
    metric3Label: '数据点/秒',
    exploreDashboard: '探索仪表盘'
  },
  compliance: {
    sectionTitle: 'CBAM 合规，轻松实现',
    sectionSubtitle: '自动化碳足迹追踪与欧盟合规文档',
    card1Title: '自动化报告',
    card1Desc: '利用实时碳排放数据自动生成合规报告',
    card2Title: '碳足迹追踪',
    card2Desc: '追踪并分析整个生产链的碳排放情况',
    card3Title: '合规文档',
    card3Desc: '欧盟 CBAM 合规文档与认证的预置模板',
    downloadGuide: '下载合规指南',
    viewDetails: '了解更多'
  },
  cbam: {
    badge: '欧盟 CBAM 数字化要求',
    modalTitle: 'CBAM 数字化系统核心要求',
    modalSubtitle: '从数据层级到 MRV 全流程数字化——满足欧盟碳边境合规要求',
    tab1: '数据层级：组织 → 产品/产线级',
    tab2: 'MRV 全流程数字化',
    dataLayerIntroTitle: 'CBAM 要求产品级排放数据，而非企业总量',
    dataLayerIntroDesc: 'CBAM 要求报告每吨产品的内嵌排放量，包括直接+间接排放、生产线/工序级分配，以及优先采用实测值而非估算值。',
    dataHierarchyTitle: '三级数据层级',
    level1Label: '第一级 — 组织',
    level1Title: '企业/集团级',
    level1Desc: '在企业层面汇总能源消耗和碳排放总量。适用于年度可持续发展报告和 ESG 披露，但不满足 CBAM 产品级要求。',
    level1Limit: '局限性：无法将排放量分配到具体产品或批次——不符合 CBAM 要求。',
    level2Label: '第二级 — 设施',
    level2Title: '工厂/产线级',
    level2Desc: '按生产线或工艺单元追踪能源和排放。支持将碳成本分配到产品类别，并支持工序级 KPI 管理。',
    level2Limit: '部分合规：支持产线级分配，但可能缺乏批次追踪所需的实时粒度。',
    level3Label: '第三级 — 设备',
    level3Title: '设备/批次级（CBAM 核心）',
    level3Desc: '在设备层面从 DCS/SCADA/PLC 实时采集数据。实现每个产品批次的精确能源和排放归因，满足 CBAM 实测优先要求。',
    level3Limit: '完全合规：实时测量 + 批次追踪 + 产品级分配——CBAM 的黄金标准。',
    cbamRequired: 'CBAM 必需',
    deviceCapTitle: 'BridgeAI 设备级采集能力',
    deviceCapDesc: 'BridgeAI 通过 Modbus、OPC-UA、Snap7 等 15+ 种工业协议直接连接 DCS、SCADA 和 PLC 系统。能源和排放数据按设备、按批次采集，并自动分配到产品——将设备级数据转化为 CBAM 合规证据。',
    mrvIntroTitle: '欧盟 MRV 法规：碳数据三大核心要求',
    mrvIntroDesc: '欧盟监测、报告和核查（MRV）框架要求，所有提交给 CBAM 的碳排放数据必须可追溯、可核查且防篡改。数字化系统必须提供端到端的证据链。',
    mrvPillarsTitle: 'MRV 三大支柱',
    mrv1Title: '可追溯——数据来源可审计',
    mrv1Desc: '每个数据点必须可追溯至源头仪器。校准记录、传感器元数据和测量时间戳必须存储并可查询。BridgeAI 自动记录每次读数的设备校准状态和数据来源。',
    mrv1Tag1: '仪器校准记录',
    mrv1Tag2: '传感器元数据',
    mrv1Tag3: '测量时间戳',
    mrv2Title: '可核查——支持第三方审计',
    mrv2Desc: '数据必须支持经认可的第三方机构现场核查。BridgeAI 提供结构化审计导出、数据回放和核查人员角色访问——在不影响运营的情况下实现无缝第三方审查。',
    mrv2Tag1: '结构化审计导出',
    mrv2Tag2: '数据回放',
    mrv2Tag3: '核查人员访问控制',
    mrv3Title: '防篡改——区块链公证',
    mrv3Desc: '排放记录必须不可篡改。BridgeAI 支持对关键数据快照进行区块链公证——创建加密证明，证明记录自提交以来未被更改，满足欧盟防篡改要求。',
    mrv3Tag1: '区块链公证',
    mrv3Tag2: '加密哈希',
    mrv3Tag3: '不可变审计追踪',
    mrvFlowTitle: 'MRV 数字证据链',
    mrvFlow1: '设备\n测量',
    mrvFlow2: '安全\n存储',
    mrvFlow3: '区块链\n公证',
    mrvFlow4: '合规\n报告',
    mrvFlow5: '第三方\n核查',
    stat1Val: '100%',
    stat1Label: '数据可追溯性',
    stat2Val: 'ISO 14064',
    stat2Label: '核查就绪',
    stat3Val: '区块链',
    stat3Label: '防篡改',
  },
  testimonials: {
    sectionTitle: '受到行业领袖的信赖',
    review1Title: '颠覆性平台',
    review1Text: 'BridgeAI 彻底改变了我们的制造运营。实时监控和 AI 告警将停机时间减少了 40%。',
    review1Name: 'Michael Chen',
    review1Position: '运营总监，TechManufacturing Co.',
    review2Title: 'CBAM 合规变得简单',
    review2Text: '自动化合规报告为我们节省了大量时间。欧盟 CBAM 文档现在轻而易举。',
    review2Name: 'Sarah van der Berg',
    review2Position: '可持续发展经理，GreenIndustries NL',
    review3Title: '卓越的数据洞察',
    review3Text: '分析能力非常出色。我们现在可以提前数周预测设备故障。',
    review3Name: 'Klaus Müller',
    review3Position: '首席技术官，Industrie Solutions GmbH',
    review4Title: '无缝 ERP 集成',
    review4Text: '与现有 ERP 系统的集成非常顺畅。多语言支持非常适合我们的全球团队。',
    review4Name: 'Emma Johnson',
    review4Position: 'IT 总监，GlobalTech Industries',
    review5Title: '卓越的支持',
    review5Text: '可定制的仪表盘和基于角色的权限与我们的组织结构完美契合。',
    review5Name: 'Pierre Dubois',
    review5Position: '工厂经理，EuroManufacturing SA',
    review6Title: '3 个月内实现 ROI',
    review6Text: '我们在三个月内看到了可量化的投资回报。仅预测性维护一项就已覆盖平台成本。',
    review6Name: 'Anna Kowalski',
    review6Position: '首席财务官，Industrial Dynamics Ltd.'
  },
  cta: {
    title: '准备好转型您的运营了吗？',
    subtitle: '开始 30 天免费试用，无需信用卡',
    getStarted: '立即开始'
  },
  footer: {
    tagline: '赋能工业数字化转型',
    platformTitle: '平台',
    dashboard: '仪表盘',
    analytics: '数据分析',
    monitoring: '监控',
    compliance: '合规',
    solutionsTitle: '解决方案',
    iotDevices: '物联网设备',
    dataManagement: '数据管理',
    aiAlerts: 'AI 告警',
    cbamCompliance: 'CBAM 合规',
    resourcesTitle: '资源',
    documentation: '文档',
    apiReference: 'API 参考',
    caseStudies: '案例研究',
    blog: '博客',
    companyTitle: '公司',
    about: '关于我们',
    careers: '招聘',
    contact: '联系我们',
    privacy: '隐私政策',
    stayConnected: '保持联系',
    newsletterText: '获取平台更新和行业洞察',
    emailPlaceholder: '输入您的邮箱',
    subscribe: '订阅',
    subscribing: '订阅中...',
    subscribeSuccess: '订阅成功，感谢您！',
    errorInvalidEmail: '请输入有效的邮箱地址',
    errorSubmission: '订阅失败，请重试',
    copyright: '© 2026 BridgeAI. 保留所有权利。'
  },
  dataLifecycle: {
    modalTitle: '数据生命周期管理',
    modalSubtitle: '端到端工业数据流——从设备到仪表盘',
    flowLabel: '完整数据流',
    flowTitle: '从工业设备到洞察',
    flowDesc: 'BridgeAI 管理完整的数据旅程：从现场设备采集原始遥测数据，在边缘处理，安全传输到云端，并通过仪表盘和 API 提供可操作的洞察。',
    step1Title: '工业设备',
    step1Desc: '通过 Modbus、RS485、OPC-UA、Snap7、PROFINET 等协议连接 PLC、驱动器、仪表和控制器。',
    step2Title: '传感器遥测采集',
    step2Desc: '高频采集温度、压力、振动、流量、电力和自定义传感器数据。',
    step3Title: '智能边缘处理',
    step3Desc: '本地边缘设备在传输前过滤、聚合和压缩数据——带宽减少高达 80%。',
    step4Title: '安全传输',
    step4Desc: '通过 MQTT、自定义 TCP/UDP、HTTP/REST 或 WebSocket 将数据发送到云端，采用端到端 TLS 加密。',
    step5Title: 'ETL 管道',
    step5Desc: '通过验证和丰富化提取、转换和加载数据，确保质量和一致性。',
    step6Title: '数据总线',
    step6Desc: '通过 Kafka 或 RabbitMQ 事件总线分发数据流，解耦生产者和消费者。',
    step7Title: '存储层',
    step7Desc: '将数据持久化到 PostgreSQL（关系记录）、TimescaleDB/InfluxDB（时序数据）和 S3（归档）。',
    step8Title: '数据管道',
    step8Desc: '通过常规处理、AI 推理、告警评估和报告生成管道路由数据。',
    step9Title: 'Web 与应用展示',
    step9Desc: '通过实时 Web 仪表盘、移动应用、REST API、Webhook 和 ERP 集成提供洞察。',
    pipelinesTitle: '处理管道类型',
    pipeline1Title: '常规处理管道',
    pipeline1Desc: '用于聚合、KPI 计算、阈值告警和定时报告生成的标准数据流。以低延迟和高可靠性处理大多数运营数据。',
    pipeline2Title: 'AI 处理管道',
    pipeline2Desc: '用于异常检测、预测性维护和模式识别的机器学习推理管道。模型基于历史数据训练并持续更新。',
    stat1: '端到端延迟',
    stat2: '数据点/秒',
    stat3: '平台正常运行时间',
    stat4: '工业协议',
  },
  aiAlerts: {
    modalTitle: 'AI 智能告警',
    modalSubtitle: '双模告警：用户自定义规则 + AI 自动异常检测',
    badge: '智能告警引擎',
    flowTitle: '提前掌握每一个问题',
    flowDesc: 'BridgeAI 将用户自定义规则告警与 AI 驱动的异常检测相结合——在出现问题时，甚至在问题发生之前，立即通知您。',
    flowLabel: '告警处理流程',
    flow1: '传感器数据',
    flow2: '规则引擎',
    flow3: 'AI 分析',
    flow4: '触发告警',
    flow5: '通知',
    flow6: '处理/修复',
    dualModeLabel: '双告警模式',
    rule1Title: '用户自定义规则告警',
    rule1Desc: '基于阈值、条件、时间窗口和多指标逻辑创建自定义告警规则。完全掌控何时以及如何收到通知。',
    rule2Title: 'AI 自动异常检测',
    rule2Desc: 'AI 持续学习您设备的正常行为，并在检测到异常、异常模式或早期故障迹象时自动发出告警——无需任何规则。',
    featuresLabel: '告警能力',
    feat1Title: '多渠道通知',
    feat1Desc: '通过邮件、短信、Webhook、PagerDuty 或 Slack 发送告警——即时触达相关人员。',
    feat2Title: '预测性洞察',
    feat2Desc: 'AI 趋势分析和预测帮助您了解根本原因并预测未来问题。',
    feat3Title: '告警历史与审计',
    feat3Desc: '完整的告警日志，包含审计追踪、回放和导出——对每个事件保持完整可见性。',
    feat4Title: '智能告警管理',
    feat4Desc: '优先级、升级策略、抑制和分组，减少噪音，专注于重要事项。',
    stat1: '告警延迟',
    stat2: '检测准确率',
    stat3: '规则类型',
    stat4: '通知渠道',
  },
  cbamModal: {
    badge: '欧盟 CBAM 数字化要求',
    modalTitle: 'CBAM 数字化系统核心要求',
    modalSubtitle: '从数据层级到 MRV 全流程数字化——满足欧盟碳边境合规要求',
    tab1: '数据层级：组织 → 产品/产线级',
    tab2: 'MRV 全流程数字化',
    dataLayerIntroTitle: 'CBAM 要求产品级排放数据，而非企业总量',
    dataLayerIntroDesc: 'CBAM 要求报告每吨产品的内嵌排放量，包括直接+间接排放、生产线/工序级分配，以及优先采用实测值而非估算值。',
    dataHierarchyTitle: '三级数据层级',
    level1Label: '第一级 — 组织',
    level1Title: '企业/集团级',
    level1Desc: '在企业层面汇总能源消耗和碳排放总量。适用于年度可持续发展报告和 ESG 披露，但不满足 CBAM 产品级要求。',
    level1Limit: '局限性：无法将排放量分配到具体产品或批次——不符合 CBAM 要求。',
    level2Label: '第二级 — 设施',
    level2Title: '工厂/产线级',
    level2Desc: '按生产线或工艺单元追踪能源和排放。支持将碳成本分配到产品类别，并支持工序级 KPI 管理。',
    level2Limit: '部分合规：支持产线级分配，但可能缺乏批次追踪所需的实时粒度。',
    level3Label: '第三级 — 设备',
    level3Title: '设备/批次级（CBAM 核心）',
    level3Desc: '在设备层面从 DCS/SCADA/PLC 实时采集数据。实现每个产品批次的精确能源和排放归因，满足 CBAM 实测优先要求。',
    level3Limit: '完全合规：实时测量 + 批次追踪 + 产品级分配——CBAM 的黄金标准。',
    cbamRequired: 'CBAM 必需',
    deviceCapTitle: 'BridgeAI 设备级采集能力',
    deviceCapDesc: 'BridgeAI 通过 Modbus、OPC-UA、Snap7 等 15+ 种工业协议直接连接 DCS、SCADA 和 PLC 系统。能源和排放数据按设备、按批次采集，并自动分配到产品——将设备级数据转化为 CBAM 合规证据。',
    mrvIntroTitle: '欧盟 MRV 法规：碳数据三大核心要求',
    mrvIntroDesc: '欧盟监测、报告和核查（MRV）框架要求，所有提交给 CBAM 的碳排放数据必须可追溯、可核查且防篡改。数字化系统必须提供端到端的证据链。',
    mrvPillarsTitle: 'MRV 三大支柱',
    mrv1Title: '可追溯——数据来源可审计',
    mrv1Desc: '每个数据点必须可追溯至源头仪器。校准记录、传感器元数据和测量时间戳必须存储并可查询。BridgeAI 自动记录每次读数的设备校准状态和数据来源。',
    mrv1Tag1: '仪器校准记录',
    mrv1Tag2: '传感器元数据',
    mrv1Tag3: '测量时间戳',
    mrv2Title: '可核查——支持第三方审计',
    mrv2Desc: '数据必须支持经认可的第三方机构现场核查。BridgeAI 提供结构化审计导出、数据回放和核查人员角色访问——在不影响运营的情况下实现无缝第三方审查。',
    mrv2Tag1: '结构化审计导出',
    mrv2Tag2: '数据回放',
    mrv2Tag3: '核查人员访问控制',
    mrv3Title: '防篡改——区块链公证',
    mrv3Desc: '排放记录必须不可篡改。BridgeAI 支持对关键数据快照进行区块链公证——创建加密证明，证明记录自提交以来未被更改，满足欧盟防篡改要求。',
    mrv3Tag1: '区块链公证',
    mrv3Tag2: '加密哈希',
    mrv3Tag3: '不可变审计追踪',
    mrvFlowTitle: 'MRV 数字证据链',
    mrvFlow1: '设备\n测量',
    mrvFlow2: '安全\n存储',
    mrvFlow3: '区块链\n公证',
    mrvFlow4: '合规\n报告',
    mrvFlow5: '第三方\n核查',
    stat1Val: '100%',
    stat1Label: '数据可追溯性',
    stat2Val: 'ISO 14064',
    stat2Label: '核查就绪',
    stat3Val: '区块链',
    stat3Label: '防篡改',
  },
  contactForm: {
    title: '申请演示',
    fields: {
      name: '姓名',
      company: '公司名称',
      email: '电子邮箱',
      phone: '电话号码',
      message: '留言'
    },
    placeholders: {
      name: '请输入您的姓名',
      company: '请输入公司名称',
      email: '请输入电子邮箱',
      phone: '请输入电话号码',
      message: '请告诉我们您的需求...'
    },
    errors: {
      nameRequired: '姓名为必填项',
      companyRequired: '公司名称为必填项',
      emailRequired: '电子邮箱为必填项',
      emailInvalid: '请输入有效的电子邮箱地址',
      phoneRequired: '电话号码为必填项',
      messageRequired: '留言为必填项',
      messageTooLong: '留言不能超过 500 个字符'
    },
    submit: '提交申请',
    submitting: '提交中...',
    successTitle: '感谢您！',
    successMessage: '我们已收到您的申请，将尽快与您联系。'
  },
  about: {
    title: '关于我们',
    introTitle: '我们是谁',
    introText: 'BridgeAI 是工业物联网和数字化转型解决方案的领先提供商。我们通过尖端技术和 AI 驱动的洞察，帮助制造商优化运营、减少碳足迹并实现欧盟合规。',
    missionTitle: '我们的使命',
    missionText: '通过智能、数据驱动的解决方案赋能工业企业，推动卓越运营和可持续增长。',
    visionTitle: '我们的愿景',
    visionText: '成为工业数字化转型的全球标准，打造更智能、更绿色、更高效的制造业未来。',
    valuesTitle: '核心价值观',
    value1Title: '创新',
    value1Text: '持续突破工业物联网和 AI 技术的边界。',
    value2Title: '可靠性',
    value2Text: '提供客户可信赖的稳健、安全、关键任务解决方案。',
    value3Title: '可持续性',
    value3Text: '致力于帮助行业减少环境影响，实现碳中和。',
    value4Title: '合作伙伴关系',
    value4Text: '基于共同成功和共同价值观建立长期合作关系。',
    teamTitle: '我们的团队',
    teamText: '我们的团队由行业资深人士、数据科学家和物联网专家组成，在制造、自动化和企业软件领域拥有数十年的综合经验。我们带来深厚的领域专业知识和解决复杂工业挑战的热情。',
    teamExperts: '行业专家',
    teamYears: '年经验',
    teamProjects: '项目交付'
  },
  contact: {
    title: '联系我们',
    infoTitle: '取得联系',
    infoText: '对 BridgeAI 有疑问或想了解更多？我们的团队随时为您提供帮助。请通过以下任一渠道联系我们。',
    addressTitle: '办公地址',
    addressText: 'Hengelosestraat 581, 7581 AG Enschede, 荷兰',
    emailTitle: '电子邮箱',
    phoneTitle: '电话',
    hoursTitle: '营业时间',
    hoursText: '周一至周五：上午 9:00 - 下午 6:00（中欧时间）',
    formTitle: '给我们发消息',
    name: '姓名',
    company: '公司名称',
    email: '电子邮箱',
    phone: '电话号码',
    message: '留言',
    namePlaceholder: '请输入您的姓名',
    companyPlaceholder: '请输入公司名称',
    emailPlaceholder: '请输入电子邮箱',
    phonePlaceholder: '请输入电话号码',
    messagePlaceholder: '请告诉我们如何为您提供帮助...',
    errorName: '姓名为必填项',
    errorCompany: '公司名称为必填项',
    errorEmail: '电子邮箱为必填项',
    errorEmailInvalid: '请输入有效的电子邮箱地址',
    errorPhone: '电话号码为必填项',
    errorMessage: '留言为必填项',
    errorMessageLength: '留言不能超过 500 个字符',
    submit: '发送消息',
    submitting: '发送中...',
    successMessage: '感谢您！您的消息已成功发送。'
  },
  privacy: {
    title: '隐私政策',
    lastUpdated: '最后更新：',
    lastUpdatedDate: '2026年1月15日',
    introTitle: '简介',
    introText: 'BridgeAI（"我们"）致力于保护您的隐私。本隐私政策说明了当您使用我们的工业物联网平台和服务时，我们如何收集、使用、披露和保护您的信息。',
    collectionTitle: '我们收集的信息',
    collectionText: '我们收集您直接提供给我们的信息，包括：',
    collectionItem1: '个人身份信息（姓名、电子邮箱、电话号码、公司名称）',
    collectionItem2: '账户凭据和身份验证数据',
    collectionItem3: '工业设备数据、传感器读数和遥测信息',
    collectionItem4: '使用数据、日志文件和分析信息',
    usageTitle: '我们如何使用您的信息',
    usageText: '我们使用收集的信息来：',
    usageItem1: '提供、维护和改进我们的平台和服务',
    usageItem2: '处理交易并发送相关信息',
    usageItem3: '发送技术通知、更新、安全警报和支持消息',
    usageItem4: '回应您的评论、问题和客户服务请求',
    storageTitle: '数据存储与安全',
    storageText: '我们实施行业标准安全措施来保护您的数据，包括加密、访问控制和定期安全审计。您的工业数据存储在符合欧盟标准的安全数据中心，具备冗余和备份系统。',
    sharingTitle: '信息共享',
    sharingText: '我们不会向第三方出售、交易或出租您的个人信息。我们仅在以下情况下共享您的信息：',
    sharingNote: '重要提示：',
    sharingNoteText: '未经您的明确同意，我们绝不会共享您的工业设备数据或专有信息。',
    rightsTitle: '您的权利',
    rightsText: '根据 GDPR 和适用的数据保护法律，您拥有以下权利：',
    rightAccessTitle: '访问权',
    rightAccessText: '申请获取您个人数据的副本',
    rightCorrectTitle: '更正权',
    rightCorrectText: '申请更正不准确的数据',
    rightDeleteTitle: '删除权',
    rightDeleteText: '申请删除您的个人数据',
    rightPortabilityTitle: '数据可携带权',
    rightPortabilityText: '申请将您的数据转移到其他服务',
    cookiesTitle: 'Cookies 与追踪',
    cookiesText: '我们使用 Cookies 和类似追踪技术来追踪平台上的活动并存储某些信息。您可以设置浏览器拒绝所有 Cookies 或在发送 Cookie 时进行提示。',
    contactTitle: '联系我们',
    contactText: '如果您对本隐私政策有任何疑问或希望行使您的数据保护权利，请通过以下方式联系我们：'
  }
};
